export const qhpHeaders = [
    {key: 'originalVsAdded', header: 'Original vs. Added', sortKey: 'original_vs_added'},
    {key: 'specialtyCodes', header: 'Specialty Codes', sortKey: 'specialty_code'},
    {key: 'npi', header: 'National Provider Identifier (NPI) Number', sortKey: 'npi'},
    {key: 'fullName', header: 'Name of Physician or Mid-Level Practitioner', sortKey: 'full_name'},
    {key: 'streetAddress', header: 'Street Address', sortKey: 'street_address'},
    {key: 'city', header: 'City', sortKey: 'city'},
    {key: 'state', header: 'State', sortKey: 'state'},
    {key: 'zipCode', header: 'ZIP Code', sortKey: 'zip_code'},
];
